import * as angular from 'angular';
import { EsignaturesSignController } from './pages/esignatures-sign/esignatures-sign.page';
import { EsignaturesCanceledController } from './pages/esignatures-canceled/esignatures-canceled.page';
import { EsignaturesUnauthorizedController } from './pages/esignatures-unauthorized/esignatures-unauthorized.page';
import { EsignaturesExpiredController } from './pages/esignatures-expired/esignatures-expired.page';
import { EsignaturesSignedController } from './pages/esignatures-signed/esignatures-signed.page';
import { PublicEsignatureRoutes } from './public-esignatures.routes';
import { PublicEsignaturesApi } from './services/public-esignatures-api';
import { ManagerPublicAuthenticationBaseModule } from '../../../../manager-base/app-base/public/authentication/manager-public-authentication-base.module';
import { HelpCenterUrlModule } from '../../../../manager-base/help-center-url/help-center-url.module';
import { EsignaturesDownController } from './pages/esignatures-down/esignatures-down.page';

export const PublicEsignaturesModule = angular.module('buildium.authentication.esignatures', [
    ManagerPublicAuthenticationBaseModule.name,
    HelpCenterUrlModule.name
])
    .config(PublicEsignatureRoutes)
    .service('PublicEsignaturesApi', PublicEsignaturesApi)
    .controller('EsignaturesSignController', EsignaturesSignController)
    .controller('EsignaturesCanceledController', EsignaturesCanceledController)
    .controller('EsignaturesUnauthorizedController', EsignaturesUnauthorizedController)
    .controller('EsignaturesExpiredController', EsignaturesExpiredController)
    .controller('EsignaturesSignedController', EsignaturesSignedController)
    .controller('EsignaturesDownController', EsignaturesDownController);
